import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingLoginService {

  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { }

  // This function get Guest list
  GuestDetail(OnlinePatientRegistrationID, ActivateOnly, LoginOnlineUserRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetAll?&OnlinePatientRegistrationID=' + OnlinePatientRegistrationID
      + '&ActivateOnly=' + ActivateOnly + '&LoginOnlineUserRegistrationID=' + LoginOnlineUserRegistrationID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  // This function generate Booking code
  BookingCode() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetBookingCode', { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  // This function saves/updates Guest
  SaveGuest(Guest) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking', Guest, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function saves Booking
  SaveBooking(BookingPayment) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/SaveBooking', BookingPayment,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function saves Reschedule Booking
  SaveRescheduleBooking(BookingPayment) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/SaveRescheduleBooking', BookingPayment,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function is used to send OTP on user's email using provided userid/email/mobile no
  SendOTPForLoginWithOTP(UserName) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/SendOTPForLoginWithOTP?UserName=' + UserName,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Get Guest all booking history
  GetBookingHistory(OnlinePatientRegistrationID, FromDate, ToDate) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetBookingHistory?OnlinePatientRegistrationID=' + OnlinePatientRegistrationID + '&FromDate=' + FromDate + '&ToDate=' + ToDate,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // save Questionnaire
  saveQuestionnaire(Questionnaire) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/saveQuestionnaire', Questionnaire,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Activate or Deactivate Guest By Id
  ActivateDeactivateById(OnlinePatientRegistrationID, Status, Nationality, AadharNo, PassportNo, PatientID, GuestName) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.delete<any>(environment.apiUrl + 'Booking/ActivateDeactivateById?OnlinePatientRegistrationID=' + OnlinePatientRegistrationID +
      '&Status=' + Status + '&Nationality=' + Nationality + '&AadharNo=' + AadharNo + '&PassportNo=' + PassportNo +
      '&PatientID=' + PatientID + '&GuestName=' + GuestName, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Get Country and Nationalty list from mstcountry
  GetCountryandNationality() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetCountryandNationality', { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Check previous booking 6 month complited or not.
  GetBookingeligibility(Nationality, AadharNo, PassportNo, PatientID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetBookingeligibility?Nationality=' + Nationality +
      '&AadharNo=' + AadharNo + '&PassportNo=' + PassportNo + '&PatientID=' + PatientID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Deactivating Booking
  DeactivateBookingID(PatientID, BookingID: number, OnlinePatientRegistrationID, deductedAmount, finalAmount, AdvanceAmount, UserName: string, CancellationReason, ActiononBalance, GuestEmail, CarryforwardBookingID, BookingCode) {
    const customHeaders = this.globals.GetCustomHeadersForDelete();
    return this.http.delete<any>(environment.apiUrl + 'Booking/DeactivateBookingID?BookingID=' + BookingID +
      '&deductedAmount=' + deductedAmount + '&finalAmount=' + finalAmount + '&OnlinePatientRegistrationID=' + OnlinePatientRegistrationID + '&AdvanceAmount=' + AdvanceAmount +
      '&userName=' + UserName + '&PatientID=' + PatientID + '&CancellationReason=' + CancellationReason + '&ActiononBalance=' + ActiononBalance + '&GuestEmail=' + GuestEmail +
      '&CarryforwardBookingID=' + CarryforwardBookingID + '&BookingCode=' + BookingCode,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  SavePatientHistorySheetQuestionnaire(itemToEditPatientHistory) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/SavePatientHistorySheetQuestionnaire', itemToEditPatientHistory, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  CheckAdmissionandPatientHistoryYear(SelectedOnlinePatientRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/CheckAdmissionandPatientHistoryYear?OnlinePatientRegistrationID=' + SelectedOnlinePatientRegistrationID,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Get Previous Balance with BookingID
  GetPreviousBalancewithBookingID(SelectedOnlinePatientRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetPreviousBalancewithBookingID?OnlinePatientRegistrationID=' + SelectedOnlinePatientRegistrationID,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Transfer Patient under new user
  UpdateUserForPatient(OnlinePatientRegistrationID, OnlineUserRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/UpdateUserForPatient?OnlinePatientRegistrationID=' + OnlinePatientRegistrationID +
      '&OnlineUserRegistrationID=' + OnlineUserRegistrationID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Update BookingID in Booking Questionnaire for hold Patient
  UpdateBookingIDforQuestionnaire(SelectedOnlinePatientRegistrationID, OldBookingID, BookingID) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/UpdateBookingIDforQuestionnaire?OnlinePatientRegistrationID=' + SelectedOnlinePatientRegistrationID +
      '&BookingID=' + BookingID + '&OldBookingID=' + OldBookingID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Get Recommended +/- 10 Booking Dates for selected class
  GetRecommendedBookingDates(checkinDate, AdmissionDuration, ClassID, RoomCategoryName) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetRecommendedBookingDates?checkinDate=' + checkinDate + '&AdmissionDuration=' +
      AdmissionDuration + '&ClassID=' + ClassID + '&RoomCategoryName=' + RoomCategoryName,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function saves Booking
  SaveFailedAndCancelPayment(BookingPayment) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'Booking/SaveFailedAndCancelPayment', BookingPayment,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function is used to upload/copy user selected file on cloud server
  UploadFileToCloud(formData) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    const endpoint = environment.apiUrl + 'ImageUpload/UploadFileToCloud';
    return this.http
      .post<any>(endpoint, formData)
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function is used to Delete file from drop box
  DeleteFileFromCloud(FilePath, FileUploadID, UserName, FileName, ClientID, LocationID, FileUploadServerType, ClientDetails) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'ImageUpload/DeleteFileFromCloud?FilePath=' + FilePath + '&token='
      + '&FileUploadID=' + FileUploadID + '&user=' + UserName + '&FileName=' + FileName + '&ClientID=' + ClientID + '&LocationID=' + LocationID +
      '&FileUploadServerType=' + FileUploadServerType + '&ClientDetails=' + ClientDetails, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  // This function is used to get all image for selected patient and client , location
  GetAllFilesForPatient(PatientID, ClientID, LocationID, SelectedOnlinePatientRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'ImageUpload/GetAllFilesForPatient?PatientID=' + PatientID
      + '&ClientID=' + ClientID + '&LocationID=' + LocationID + '&OnlinePatientRegistrationID=' + SelectedOnlinePatientRegistrationID,
      { headers: new HttpHeaders(customHeaders) }).pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // this function is used to view/download file uploaded
  GetAtachementFile(filename, type, ClientID, LocationID, FileUploadServerType, ClientDetails) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'ImageUpload/GetAtachementFile?filename=' + filename + '&type=' + type
      + '&ClientID=' + ClientID + '&LocationID=' + LocationID + '&FileUploadServerType=' + FileUploadServerType + '&ClientDetails=' + ClientDetails, { headers: new HttpHeaders(customHeaders) })
      .pipe(
        catchError((error: any) => {
          throw error;
        }));
  }

  SendHoldWhatsAppMessage(GuestName, GSM, ClientID, LocationID, PatientID, UHID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/SendHoldWhatsAppMessage?GuestName=' + GuestName + '&GSM=' + GSM
      + '&ClientID=' + ClientID + '&LocationID=' + LocationID + '&PatientID=' + PatientID + '&UHID=' + UHID, { headers: new HttpHeaders(customHeaders) })
      .pipe(
        catchError((error: any) => {
          throw error;
        }));
  }

  GetRoomCategories() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(
      environment.apiUrl + 'Booking/GetRoomCategories', { headers: new HttpHeaders(customHeaders) }
    ).pipe(
      catchError((error: any) => {
        throw error;
      })
    );
  }

  GetTariff() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetTariff', { headers: new HttpHeaders(customHeaders) }
    ).pipe(
      catchError((error: any) => {
        throw error;
      })
    );
  }

}
